import { AuthFailedException } from './auth-failed-exception';

/**
 * Exception type covering authorization errors.
 **/
export class AuthorizationFailedException extends AuthFailedException {
  name = 'AuthorizationFailedException';

  constructor(message) {
    super(message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, AuthorizationFailedException.prototype);
  }
}
